import { useState } from "react";
import { FAQS } from "../data";
import { trackFaqOpen, trackFaqClose, trackContactClick } from "../analytics";
import { useSectionTrack } from "../hooks/useSectionTrack";

export default function FAQ() {
  const [open, setOpen] = useState(null);
  const ref = useSectionTrack("faq");

  const toggle = (i) => {
    if (open === i) { trackFaqClose(i); setOpen(null); }
    else            { trackFaqOpen(i, FAQS[i].q); setOpen(i); }
  };

  return (
    <section ref={ref} id="faq" className="sec" style={{ background: "transparent" }}>
      <div className="faq-layout">

        <div className="faq-sticky" style={{ position: "sticky", top: 100 }}>
          <div className="faq-eyebrow">FAQ</div>
          <h2 className="faq-h2">Ещё вопросы?</h2>
          <p className="faq-intro">Если не нашёл ответа — пиши напрямую. Отвечаем быстро и без скриптов.</p>
          <a
            href="mailto:support@wychodzi.app"
            className="faq-mail glass"
            onClick={() => trackContactClick("email", "faq")}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            support@wychodzi.app
          </a>
        </div>

        <div>
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="faq-item">
                <button className="faq-trigger" onClick={() => toggle(i)}>
                  <span className="faq-q">{item.q}</span>
                  <div className={`faq-toggle ${isOpen ? "faq-toggle-open" : "glass"}`}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke={isOpen ? "#fff" : "#fff"} strokeWidth="2.5" strokeLinecap="round"
                      style={{ transform: isOpen ? "rotate(45deg)" : "none", transition: "transform .2s" }}>
                      <path d="M12 5v14M5 12h14"/>
                    </svg>
                  </div>
                </button>
                <div className="faq-a-wrap" style={{ maxHeight: isOpen ? 300 : 0 }}>
                  <p className="faq-a">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
